import { Routes } from "@angular/router";

export const stockRoutes: Routes = [
  {
    path: "",
    loadChildren: () => import("./domains/stock/stock.routes").then(m => m.stockRoutes),
  },
];
